import Axios from "../connection";
import { applicationError } from "../../../redux/actions/error";

export const afGetSeasons = () => {
  return new Promise((resolve) => {
    Axios.get("/leagues/seasons")
      .then((response) => {
        const seasons = [
          response.data.response.pop(),
          response.data.response.pop(),
          response.data.response.pop(),
          response.data.response.pop(),
          response.data.response.pop(),
        ];
        resolve(seasons);
      })
      .catch((err) => {
        applicationError({
          err,
          message: "Unable to fetch seasons",
          errorCode: "api-football",
        });
      });
  });
};
